import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import loginHero from '@/assets/hero/login-hero.png';
import Nav from '@/features/auth/nav.component';
import { AuthLayout } from '@/shared/components/layout/auth-layout.component';
import { getStoredToken } from '@/shared/services/session.service';

export const Route = createFileRoute('/_unauthenticated')({
  component: () => (
    <AuthLayout hero={loginHero} nav={<Nav />}>
      <Outlet />
    </AuthLayout>
  ),
  beforeLoad: () => {
    if (getStoredToken()) {
      throw redirect({ to: '/home' });
    }
  },
});
